import React, { useState, useEffect, useRef } from 'react';
import './Tabs.css';

const Tabs = ({ tabs, activeTab, onTabChange }) => {
  const tabBarRef = useRef(null);
  const [showLeftScroll, setShowLeftScroll] = useState(false);
  const [showRightScroll, setShowRightScroll] = useState(false);

  const checkScroll = () => {
    if (tabBarRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = tabBarRef.current;
      setShowLeftScroll(scrollLeft > 0);
      setShowRightScroll(scrollLeft < (scrollWidth - clientWidth - 1));
    }
  };

  useEffect(() => {
    checkScroll();
    const tabBar = tabBarRef.current;
    if (tabBar) {
      tabBar.addEventListener('scroll', checkScroll);
      window.addEventListener('resize', checkScroll);
      
      const observer = new MutationObserver(checkScroll);
      observer.observe(tabBar, { childList: true, subtree: true });
      
      return () => {
        tabBar.removeEventListener('scroll', checkScroll);
        window.removeEventListener('resize', checkScroll);
        observer.disconnect();
      };
    }
  }, []);

  const scroll = (direction) => {
    if (tabBarRef.current) {
      const scrollAmount = 200;
      tabBarRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className={`tab-bar-container ${showLeftScroll ? 'has-left-scroll' : ''} ${showRightScroll ? 'has-right-scroll' : ''}`}>
      <button 
        type="button"
        className="scroll-btn left" 
        onClick={() => scroll('left')}
        aria-label="Nach links scrollen"
      />
      <div className="tab-bar" ref={tabBarRef}>
        {tabs.map((tab, idx) => (
          <button
            key={idx}
            type="button"
            className={"tab-btn" + (activeTab === idx ? " active" : "")}
            onClick={() => onTabChange(idx)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <button 
        type="button"
        className="scroll-btn right" 
        onClick={() => scroll('right')}
        aria-label="Nach rechts scrollen"
      />
    </div>
  );
};

export default Tabs;
